import Notification from './Notification';
import { useNotificationStore } from './notificationStore';
const NotificationsContainer = () => {
	const notifications = useNotificationStore((state) => state.notifications);
	return (
		<div className="z-50 w-96 toast toast-top toast-end">
			{notifications.map((notification) => (
				<Notification key={notification.id} {...notification} />
			))}
		</div>
	);
};

export default NotificationsContainer;
